import { getChainInfo } from 'uniswap/src/features/chains/chainInfo'
import { UniverseChainId } from 'uniswap/src/features/chains/types'

// No bridged base addresses needed for H2-only setup
export const BRIDGED_BASE_ADDRESSES: string[] = []

export function getNativeAddress(chainId: UniverseChainId): string {
  return getChainInfo(chainId).nativeCurrency.address
}

export function getWrappedNativeAddress(chainId: UniverseChainId): string {
  return getChainInfo(chainId).wrappedNativeCurrency?.address ?? '0x1E69ED5584b562Da61c69433b6bB5430f351B1de'
}

// Contract address mappings for H2 Chain
type AddressMap = { [chainId: number]: string }

export const V2_FACTORY_ADDRESS = '0xFBDf166cD7eE7dC68165aFb419bCF8039400D240'
export const V2_FACTORY_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: V2_FACTORY_ADDRESS,
}

// Optional override for Uniswap V2 Pair INIT_CODE_HASH per chain
export const V2_INIT_CODE_HASHES: AddressMap = {
  [UniverseChainId.H2]: '0x5a2dc30108940dd053e5fe06fe4deb55d420828f787d508920ac29e08aed3ad9',
}

// V3 Core Factory Addresses
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0xEEBA5019F59c00C829ffA51a93dbf4Fd4b539980', // UniswapV3Factory
}

// Nonfungible Position Manager Addresses  
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0xaA2b3B011ffF286Bfc72dCC2E0d187B7Dd86f99E', // NonfungiblePositionManager
}

// Quoter V2 Addresses
export const QUOTER_V2_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0xA3819E733c6b56F5A9dB4Aa69A4f23a6d7Aa0ebe', // QuoterV2
}

// Swap Router Addresses
export const SWAP_ROUTER_02_ADDRESSES = (chainId: number): string | undefined => {
  switch (chainId) {
    case UniverseChainId.H2:
      return '0x2915295EF9ba492c90dF9184D7957d9313696710' // SwapRouter
    default:
      return undefined
  }
}

// Multicall Addresses
export const MULTICALL_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0x81a5EA07828A50aCdD79B5d08a923ca18a78D5a7', // UniswapInterfaceMulticall
}

// Tick Lens Addresses
export const TICK_LENS_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0x62a6BD523C0Ae717E4B3c29F4DE489be5179aD94', // TickLens
}

// NFT Descriptor Addresses
export const NFT_DESCRIPTOR_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0xfcDbe2241e04245bd9a835D572343c9Ac35B916E', // NFTDescriptor
}

// Nonfungible Token Position Descriptor Addresses
export const NONFUNGIBLE_TOKEN_POSITION_DESCRIPTOR_ADDRESSES: AddressMap = {
  [UniverseChainId.H2]: '0x5e1213b03E7dcC5A1eAfbF890d415e5A61d505a9', // NonfungibleTokenPositionDescriptor
}

// Permit2 Address (usually the same across all chains)
export const PERMIT2_ADDRESS = '0x9d1CA5ae81b80B8046Ce869498CA85F7c27700b5'